import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ApplicantIcon from '../../assets/icons/applicants.svg';
import AttendanceIcon from '../../assets/icons/attendance.svg';
import ClassIcon from '../../assets/icons/classes.svg';
import StudentIcon from '../../assets/icons/students.svg';
import SubjectIcon from '../../assets/icons/subjects.svg';
import TeacherIcon from '../../assets/icons/teachers.svg';

const Sidebar = ({ user }) => {
    const { pathname, search } = useLocation();
    const navigate = useNavigate();
    const adminSideNav = [
        {
            id: 1,
            url: '/dashboard/applicants',
            label: 'درخواست دہندگان',
            iconSrc: ApplicantIcon,
            iconAlt: 'applicant_icon',
            active: false,
        },
        {
            id: 2,
            url: '/dashboard/students',
            label: 'طلبہ',
            iconSrc: StudentIcon,
            iconAlt: 'student_icon',
            active: false,
        },
        {
            id: 3,
            url: '/dashboard/attendance',
            label: 'حاضری',
            iconSrc: AttendanceIcon,
            iconAlt: 'attendance_icon',
            active: false,
        },
        {
            id: 4,
            url: '/dashboard/teachers',
            label: 'اساتذہ',
            iconSrc: TeacherIcon,
            iconAlt: 'teacher_icon',
            active: false,
        },
        {
            id: 5,
            url: '/dashboard/classes',
            label: 'کلاسز',
            iconSrc: ClassIcon,
            iconAlt: 'class_icon',
            active: false,
        },
        {
            id: 6,
            url: '/dashboard/subjects',
            label: 'مضامین',
            iconSrc: SubjectIcon,
            iconAlt: 'subject_icon',
            active: false,
        },
    ];
    const testerSideNav = [
        {
            id: 1,
            url: '/dashboard/applicants',
            label: 'درخواست دہندگان',
            iconSrc: ApplicantIcon,
            iconAlt: 'applicant_icon',
            active: false,
        },
    ];
    const isTestingUser = (username) => {
        const response = /test/.test(username);
        return response;
    };
    const [sidebarLinks, setSidebarLinks] = useState(
        user ? (isTestingUser(user.username) ? testerSideNav : adminSideNav) : [],
    );

    useEffect(() => {
        if (pathname === '/dashboard/applicants') {
            sidebarLinks.map((item) => {
                if (item.id === 1) {
                    item.active = true;
                } else {
                    item.active = false;
                }
                return item;
            });
            setSidebarLinks([...sidebarLinks]);
        } else if (pathname === '/dashboard/applicants/detail' && search) {
            sidebarLinks.map((item) => {
                if (item.id === 1) {
                    item.active = true;
                } else {
                    item.active = false;
                }
                return item;
            });
            setSidebarLinks([...sidebarLinks]);
        } else if (pathname === '/dashboard/students') {
            sidebarLinks.map((item) => {
                if (item.id === 2) {
                    item.active = true;
                } else {
                    item.active = false;
                }
                return item;
            });
            setSidebarLinks([...sidebarLinks]);
        } else if (pathname === '/dashboard/students/detail' && search) {
            sidebarLinks.map((item) => {
                if (item.id === 2) {
                    item.active = true;
                } else {
                    item.active = false;
                }
                return item;
            });
            setSidebarLinks([...sidebarLinks]);
        } else if (pathname === '/dashboard/attendance') {
            sidebarLinks.map((item) => {
                if (item.id === 3) {
                    item.active = true;
                } else {
                    item.active = false;
                }
                return item;
            });
            setSidebarLinks([...sidebarLinks]);
        } else if (pathname === '/dashboard/teachers') {
            sidebarLinks.map((item) => {
                if (item.id === 4) {
                    item.active = true;
                } else {
                    item.active = false;
                }
                return item;
            });
            setSidebarLinks([...sidebarLinks]);
        } else if (pathname === '/dashboard/teachers/detail' && search) {
            sidebarLinks.map((item) => {
                if (item.id === 4) {
                    item.active = true;
                } else {
                    item.active = false;
                }
                return item;
            });
            setSidebarLinks([...sidebarLinks]);
        } else if (pathname === '/dashboard/classes') {
            sidebarLinks.map((item) => {
                if (item.id === 5) {
                    item.active = true;
                } else {
                    item.active = false;
                }
                return item;
            });
            setSidebarLinks([...sidebarLinks]);
        } else if (pathname === '/dashboard/subjects') {
            sidebarLinks.map((item) => {
                if (item.id === 6) {
                    item.active = true;
                } else {
                    item.active = false;
                }
                return item;
            });
            setSidebarLinks([...sidebarLinks]);
        }
        // eslint-disable-next-line
    }, [pathname, search]);

    return (
        <div className='sidebar_container'>
            {sidebarLinks.map((link, index) => (
                <div
                    key={index + 1}
                    onClick={() => navigate(link.url)}
                    className={`flex justifyStart alignCenter w-100 ${
                        link.active ? 'active_link' : 'inactive_link'
                    }`}
                >
                    <img src={link.iconSrc} alt={link.iconAlt} height={24} width={24} />
                    <h4 className='sidebar_link'>{link.label}</h4>
                </div>
            ))}
        </div>
    );
};

export default Sidebar;
